import { useEscClose } from './Toast';

interface BottomSheetProps {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

/**
 * Full-screen backdrop + slide-up panel.
 * Closes on backdrop tap or Escape key. Renders nothing when closed.
 */
export function BottomSheet({ open, onClose, children }: BottomSheetProps) {
  useEscClose(open, onClose);
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50">
      <button aria-label="Close" onClick={onClose} className="absolute inset-0 bg-black/40" />
      <div className="fade-in absolute inset-x-0 bottom-0 rounded-t-3xl border-t border-border-subtle bg-surface shadow-2xl">
        <div className="mx-auto mt-3 h-1.5 w-10 rounded-full bg-border-subtle" />
        {children}
      </div>
    </div>
  );
}
